<template>
  <div v-if="clicked" v-on:click="getYzm()">{{showTxt}}</div><div v-else v-clearSelect>{{showTxt}}</div>
</template>
<script>
export default {
  data () {
    return {
      showTxt: this.defMsg,
      count: 0,
      clicked: true
    }
  },
  props: {
    num: {
      type: Number,
      default: 60
    },
    defMsg: {
      type: String,
      default: '获取验证码'
    },
    doingMsg: {
      type: String,
      default: 's后重新获取'
    }
  },
  methods: {
    getYzm () {
      this.clicked = false
      let timer
      this.count = this.num
      this.$emit('start', this.$el)
      this.showTxt = this.count + this.doingMsg
      timer = setInterval(() => {
        this.count--
        this.showTxt = this.count + this.doingMsg
        this.$emit('progress', this.count)
        if (this.count === 0) {
          clearInterval(timer)
          this.showTxt = this.defMsg
          this.clicked = true
          this.$emit('end', this.$el)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/VCode.vue